import { Typography } from '@mui/material'
import theme from 'src/styles/theme'
import styled from 'styled-components'

export const LabelContainer = styled.div<{hasErrors: boolean}>`
    background: ${(props) => (props.hasErrors ? theme.colors.red : theme.colors.gray)};
    text-align: center;
    padding: 4px 0;
    width: 100%;
    border-radius: 4px;
`

export const AddressText = styled(Typography)<{hasErrors: boolean}>`
    font-size: 32px !important;
    color: ${(props) => props.hasErrors && theme.colors.white}
`
